
import PropertyListRow from "@/components/PropertiesList/PropertyListRow.vue";
import Header from "@/components/Header.vue";
import {
  getNormalizedItemsByUniqueItemProp,
  getAlternativeById,
  c_alternativesIds,
  state,
} from "@/store";
import { defineComponent, ref } from "vue";

export default defineComponent({
  // props: {
  //   id: Number
  // },

  setup(props) {
    const height = ref(null);

    return {
      state,
      height,

      c_alternativesIds,

      setHeight: () => {
        const tableFilters = document.querySelector("[table-filters]");

        if (tableFilters) {
          const tableFiltersRect = tableFilters.getBoundingClientRect();
          height.value = window.innerHeight - tableFiltersRect.bottom - 24;
        }
      },
      getNormalizedItemsByUniqueItemProp,
      getAlternativeById,
    };
  },

  // data: () => ({
  //   state,
  //   height: ""
  // }),
  components: {
    Header,
    PropertyListRow,
  },

  mounted() {
    this.$nextTick(this.setHeight);
  },
  updated() {
    this.$nextTick(this.setHeight);
  },
  created() {
    window.addEventListener("resize", this.setHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.setHeight);
  },
  // methods: {

  // },
  // props: ["id"]
});
